import { useState, useEffect } from 'react'
import { Offcanvas, Card, Popover, OverlayTrigger } from 'react-bootstrap'
import { useSettings } from 'Settings'
import { v4 } from 'uuid'
import ValueTransform from 'ValueTransform'

const analyseSettings = (settings) => {
	const analysis = { warnings : []}
	const vsup = settings['vsup']
	const vaux = settings['vaux']
	const ldo = settings['ldo levels']
	const sl = settings['supervisory level']
	const sv = settings['supervisory']
	const timing = settings['timing']
	const hps = settings['harvester power supervisory']
	const acc = sl['v_lvl_acc'].value

	const analyseVaux = (i) => {
		const warning = {
			desc : `VAUX[${i}] and VSUP could be on a different voltage domain`,
			hint : `To get the same voltage domain for VSUP and VAUX[${i}] set auto + frc_ulp_ldo = 0 OR VAUX_LDO + frc_ulp_ldo = 1`
		}

		const cvaux = vaux[i]

		if (vsup['force enable'].value){
			if (cvaux['constantly connect to'].value === 1){
				if (ldo['v_ulp_ldo'].value !== ldo['v_aux_ldo'].value) {
					analysis.warnings.push(warning)
				}
			} else {
					analysis.warnings.push(warning)
			}
		} else {
			if (cvaux['constantly connect to'].value > 1){
				analysis.warnings.push(warning)
			}
		}
	}

	[0, 1, 2].forEach((i) => analyseVaux(i))

	if (ldo['v_ulp_ldo'].value > ValueTransform(sl['v_bat_max_lo'].value, acc)) {
		analysis.warnings.push({
			desc: "v_ulp_ldo voltage level is higher than v_bat_min_hi_dis",
			hint: "Set v_ulp_ldo level lower than v_bat_max_lo. The ULP LDO acts as a follower even if forced."
		})
	}

	if (ldo['v_aux_ldo'].value > ValueTransform(sl['v_bat_max_lo'].value, acc)) {
		analysis.warnings.push({
			desc: "v_aux_ldo voltage level is higher than v_bat_min_hi_dis",
			hint: "Set v_aux_ldo level lower than v_bat_max_lo. The AUX LDO acts as a follower even if forced."
		})
	}

	if (!sv['battery protector'].value) {
		analysis.warnings.push({
			desc: "No under voltage protection on LTS has been set",
			hint: "Disabling protection might be suitable for systems using super-caps or solid-stbi-exclamation-circleate battery storage elements"
		})
	}

	return analysis
}

const states = {
	"success" : "bi-check-circle",
	"danger" : "bi-exclamation-circle-fill",
}

const Warning = ({ desc, hint }) => {
	return (
		<Card className="mb-3">
			<Card.Body style={{ position : 'relative' }}>
				<span>{desc}</span>

				<OverlayTrigger
					placement="left"
					overlay={
					<Popover id={v4()}>
						<Popover.Header as="h3">Hint</Popover.Header>
						<Popover.Body>
							{hint}
						</Popover.Body>
					</Popover>
					}
					>
					<i
						style={{
							position: 'absolute',
							top: '5px',
							right: '5px'
						}}
						className="bi bi-info-circle"
					></i>
				</OverlayTrigger>
			</Card.Body>
		</Card>
	)
}

const Warnings = ({ warnings }) => {

	if (warnings.length === 0) {
		return (
			<span className="text-muted">
				No Warnings
			</span>
		)
	}

	return (
		<>
			{
			warnings.map((w) => {
				return (
				<Warning {...w} key={v4()} />
				)
			})
			}
		</>
	)
}

const ErrorPanel = (props) => {
	const [settings] = useSettings()
	const [show, setShow] = useState()

	const [state, setState] = useState("success")
	const [warnings, setWarnings] = useState([])

	const handleShow = () => setShow(true)
	const handleClose = () => setShow(false)

	useEffect(() => {
		const analysis = analyseSettings(settings)
		setWarnings(analysis.warnings)

		if (warnings.length > 0) {
			setState("danger")
		} else {
			setState("success")
		}

		}, [settings, warnings.length])

	return (
		<>
			<button
				className={`btn text-${state}`}
				style={{
					border : "none",
					marginTop : '-10px',
					marginBottom : '-10px',
				}}
				onClick={handleShow}
				>
				<i
					style={{ fontSize: '2em'}}
					className={states[state]}></i>
			</button>
			<Offcanvas
				placement="end"
				show={show}
				onHide={handleClose}
				>
				<Offcanvas.Body>
					<Offcanvas.Title className="mb-1">Warnings</Offcanvas.Title>
					<Warnings warnings={warnings} />
				</Offcanvas.Body>
			</Offcanvas>
		</>
	)
}

export default ErrorPanel
